import { Box, Button } from "@mui/material";
import { ILink } from "src/types/common";

export interface IHeroSlideCtaButton extends ILink {
    variant?: "solid" | "outline";
    colorScheme?: "gray" | "green";
}

interface IHeroSlideCtaBoxProps {
    cta1?: IHeroSlideCtaButton | null;
    cta2?: IHeroSlideCtaButton | null;
}

export const HeroSlideCtaBox = ({ cta1, cta2 }: IHeroSlideCtaBoxProps) => {
    const cta1Variant = cta1?.variant === "outline" ? "outlined" : "contained";
    const cta2Variant = cta2?.variant === "outline" ? "outlined" : "contained";

    if (!cta1 && !cta2) {
        return null;
    }

    return (
        <Box display="flex" flexDirection={{ xs: "column", sm: "column", md: "column", lg: "row" }} gap={2}>
            {cta1 && (
                <Button
                    component="a"
                    href={cta1.url}
                    target={cta1.target}
                    variant={cta1Variant}
                    color={cta1?.colorScheme ? cta1.colorScheme : undefined}
                >
                    {cta1.name}
                </Button>
            )}
            {cta2 && (
                <Button
                    component="a"
                    href={cta2.url}
                    target={cta2.target}
                    variant={cta2Variant}
                    color={cta2?.colorScheme ? cta2.colorScheme : undefined}
                >
                    {cta2.name}
                </Button>
            )}
        </Box>
    );
};
